import { useEffect, useState, useCallback, useRef } from "react";
import { getPaginatedValidationScoringConfigs } from "../services/scoringService";

interface IuseFetchPaginatedValidationScoringConfigs {
  setIsLoading: React.Dispatch<React.SetStateAction<boolean>>;
  page: any;
  pSize: any;
  searchFilterData?: any;
}

const useFetchPaginatedValidationScoringConfigs = ({
  setIsLoading,
  page,
  pSize,
  searchFilterData,
}: IuseFetchPaginatedValidationScoringConfigs) => {
  const [data, setData] = useState<any>([]);
  const abortControllerRef = useRef<AbortController | null>(null);

  const fetchData = useCallback(async () => {
    if (abortControllerRef.current) {
      abortControllerRef.current.abort();
    }
    abortControllerRef.current = new AbortController();
    setIsLoading(true);
    try {
      const statusFilter = searchFilterData?.status_filter;
      const isActive =
        statusFilter === "Active"
          ? true
          : statusFilter === "Inactive"
            ? false
            : undefined;
      const resourceId = searchFilterData?.resource_id
        ? Number(searchFilterData.resource_id)
        : undefined;
      const result = await getPaginatedValidationScoringConfigs({
        page,
        pSize,
        resourceId,
        isActive,
      });
      setData(result);
    } catch (err: any) {
      if (err.name !== "AbortError") {
        setData([]);
      }
    } finally {
      setIsLoading(false);
    }
  }, [page, pSize, setIsLoading, searchFilterData]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  useEffect(() => {
    return () => {
      if (abortControllerRef.current) {
        abortControllerRef.current.abort();
      }
    };
  }, []);

  return [data, fetchData];
};

export default useFetchPaginatedValidationScoringConfigs;

